import { Building2, Flame, Heart, Users } from "lucide-react";

interface OrgStatusWidgetProps {
  orgName: string | null;
  orgTier: number | null;
  orgMorale: number | null;
  orgHeat: number | null;
  orgMembers: Record<string, any> | any[] | null;
  compact?: boolean;
}

export function OrgStatusWidget({ orgName, orgTier, orgMorale, orgHeat, orgMembers, compact }: OrgStatusWidgetProps) {
  const tier = orgTier ?? 1;
  const morale = orgMorale ?? 50;
  const heat = orgHeat ?? 0;

  // Support manpower_roster (Record) or legacy array
  let activeMembers = 0;
  if (orgMembers && typeof orgMembers === "object" && !Array.isArray(orgMembers)) {
    activeMembers = Object.values(orgMembers).reduce((s: number, b: any) => s + (b?.status === "active" ? (b.count || 0) : 0), 0);
  } else if (Array.isArray(orgMembers)) {
    activeMembers = orgMembers.filter((m: any) => m.status === "active").length;
  }

  if (compact) {
    return (
      <div className="flex items-center gap-1.5 text-muted-foreground">
        <Building2 className="w-3 h-3" />
        <span className="text-[10px]">T{tier}</span>
        <Users className="w-2.5 h-2.5" />
        <span className="text-[10px]">{activeMembers}</span>
        <Heart className={`w-2.5 h-2.5 ${morale < 40 ? "text-destructive" : "text-green-400"}`} />
        <span className="text-[10px]">{morale}</span>
        {heat > 20 && (
          <>
            <Flame className={`w-2.5 h-2.5 ${heat > 60 ? "text-destructive" : "text-orange-400"}`} />
            <span className="text-[10px]">{heat}</span>
          </>
        )}
      </div>
    );
  }

  return (
    <div className="space-y-2">
      <div className="flex items-center gap-2">
        <Building2 className="w-4 h-4 text-muted-foreground" />
        <span className="text-sm font-medium text-foreground">{orgName || "Organization"}</span>
        <span className="text-[10px] text-muted-foreground">Tier {tier}</span>
      </div>
      <div className="flex items-center gap-3 text-xs text-muted-foreground">
        <span className="flex items-center gap-1">
          <Users className="w-3 h-3" />
          {activeMembers} members
        </span>
        <span className="flex items-center gap-1">
          <Heart className={`w-3 h-3 ${morale < 40 ? "text-destructive" : "text-green-400"}`} />
          Morale: {morale}
        </span>
        {heat > 0 && (
          <span className="flex items-center gap-1">
            <Flame className={`w-3 h-3 ${heat > 60 ? "text-destructive" : "text-orange-400"}`} />
            Heat: {heat}
          </span>
        )}
      </div>
    </div>
  );
}
